import { render, staticRenderFns } from "./createBrands.vue?vue&type=template&id=2f4e4082&"
import script from "./createBrands.vue?vue&type=script&lang=js&"
export * from "./createBrands.vue?vue&type=script&lang=js&"
import style0 from "./createBrands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports